import { mergeStepGuided } from './sharedJourneyGuided';

export const LANGTANG_GUIDED_META = {
	productName: 'Guided Journey',
	tagline: 'Always know the next step — complete each task with confidence.',

	preparationTimeline: [
		{ daysBefore: 90, label: 'Passport validity', task: 'Check passport valid 6+ months beyond return', stepId: 'visa' },
		{ daysBefore: 75, label: 'Book international flights', task: 'Book return flights to Kathmandu', stepId: 'flights' },
		{ daysBefore: 60, label: 'Buy travel insurance', task: 'Policy with 5,000m altitude if doing Kyanjin Ri', stepId: 'insurance' },
		{ daysBefore: 45, label: 'Fitness training', task: 'Hike hills 3× weekly, break in boots', stepId: 'packing' },
		{ daysBefore: 14, label: 'Apply for visa', task: 'Online or VOA plan', stepId: 'visa' },
		{ daysBefore: 7, label: 'Withdraw NPR + book jeep', task: 'Cash for trail, jeep to Syabrubesi arranged', stepId: 'kathmandu' },
		{ daysBefore: 1, label: 'Drive to Syabrubesi', task: 'Jeep from Kathmandu — sleep at trailhead', stepId: 'lukla' },
		{ daysBefore: 0, label: 'Trek begins', task: 'Syabrubesi → Lama Hotel', stepId: 'trek' },
	],

	budget: {
		currency: 'USD',
		tiers: [
			{ id: 'budget', label: 'Budget', range: '$700–950', description: 'Independent teahouse trek' },
			{ id: 'standard', label: 'Standard', range: '$1,000–1,300', description: 'Guide or porter' },
			{ id: 'comfort', label: 'Comfort', range: '$1,300–1,500', description: 'Private jeep + guide' },
		],
		items: [
			{ id: 'flights-intl', label: 'International flights', budget: 700, standard: 900, comfort: 1200 },
			{ id: 'jeep', label: 'KTM ↔ Syabrubesi jeep', budget: 30, standard: 80, comfort: 180 },
			{ id: 'visa', label: 'Visa (30 days)', budget: 50, standard: 50, comfort: 50 },
			{ id: 'insurance', label: 'Travel insurance', budget: 50, standard: 80, comfort: 120 },
			{ id: 'permits', label: 'Park permit + TIMS', budget: 40, standard: 40, comfort: 40 },
			{ id: 'guide', label: 'Guide (7 days)', budget: 0, standard: 180, comfort: 250 },
			{ id: 'porter', label: 'Porter (7 days)', budget: 0, standard: 100, comfort: 140 },
			{ id: 'food-trail', label: 'Food on trail (7 days)', budget: 175, standard: 245, comfort: 300 },
			{ id: 'lodging-trail', label: 'Lodging on trail', budget: 70, standard: 100, comfort: 140 },
			{ id: 'kathmandu', label: 'Kathmandu hotels', budget: 80, standard: 150, comfort: 250 },
			{ id: 'tips', label: 'Tips', budget: 25, standard: 50, comfort: 80 },
			{ id: 'emergency', label: 'Emergency fund', budget: 80, standard: 100, comfort: 150 },
		],
	},

	documentsWallet: [
		{ id: 'passport', label: 'Passport', note: 'Valid 6+ months beyond return' },
		{ id: 'visa', label: 'Nepal visa', note: '30-day tourist visa' },
		{ id: 'insurance', label: 'Travel insurance policy', note: '4,500–5,000m altitude cover' },
		{ id: 'flight-intl', label: 'International flight ticket', note: 'Home city ↔ Kathmandu' },
		{ id: 'permit-park', label: 'Langtang National Park permit', note: 'Obtain in Kathmandu' },
		{ id: 'permit-tims', label: 'TIMS card (if required)', note: 'Verify with NTB' },
		{ id: 'hotel', label: 'Hotel booking confirmation', note: 'Thamel, first/last nights' },
		{ id: 'emergency', label: 'Emergency contacts card', note: 'Insurer, Tourist Police 1144' },
		{ id: 'photos', label: 'Passport photos (×4)', note: 'For permits and visa' },
	],

	packingChecklist: [
		{ id: 'boots', label: 'Hiking boots (broken in)', category: 'Footwear', weight: '1.2 kg', buyAtHome: 'Outdoor retailer', rentKtm: '$2/day', needOct: true },
		{ id: 'socks', label: 'Trekking socks (×4)', category: 'Footwear', weight: '200g', buyAtHome: 'Any', rentKtm: 'Buy locally', needOct: true },
		{ id: 'sleeping-bag', label: 'Sleeping bag (-10°C)', category: 'Sleep', weight: '1.2 kg', buyAtHome: 'Outdoor shop', rentKtm: '$2/day', needOct: true },
		{ id: 'down-jacket', label: 'Down jacket', category: 'Clothing', weight: '400g', buyAtHome: 'Outdoor brand', rentKtm: '$2/day', needOct: true },
		{ id: 'rain-shell', label: 'Rain jacket', category: 'Clothing', weight: '300g', buyAtHome: 'Any', rentKtm: '$2/day', needOct: true },
		{ id: 'fleece', label: 'Fleece layer', category: 'Clothing', weight: '350g', buyAtHome: 'Any', rentKtm: 'Thamel', needOct: true },
		{ id: 'poles', label: 'Trekking poles', category: 'Gear', weight: '500g', buyAtHome: 'Outdoor shop', rentKtm: '$1/day', needOct: true },
		{ id: 'daypack', label: 'Daypack (25–30L)', category: 'Gear', weight: '700g', buyAtHome: 'Any', rentKtm: 'Rare', needOct: true },
		{ id: 'headlamp', label: 'Headlamp', category: 'Gear', weight: '100g', buyAtHome: 'Any', rentKtm: 'Thamel', needOct: true },
		{ id: 'water', label: 'Bottles + purification', category: 'Gear', weight: '200g', buyAtHome: 'Tablets', rentKtm: 'Local', needOct: true },
		{ id: 'powerbank', label: 'Power bank', category: 'Electronics', weight: '350g', buyAtHome: 'Electronics', rentKtm: 'Local', needOct: true },
		{ id: 'firstaid', label: 'First aid kit', category: 'Health', weight: '200g', buyAtHome: 'Pharmacy', rentKtm: 'Pharmacy', needOct: true },
	],

	stepGuided: mergeStepGuided({
		dream: {
			objective: 'Confirm Langtang Valley is the right trek for you',
			why: 'Closest Himalayan trek to Kathmandu — great if you want culture and mountains without Lukla flights',
			estimatedTime: '15 minutes',
			taskChecklist: [
				{ id: 'decided', label: 'I have decided to trek Langtang' },
				{ id: 'fitness-honest', label: 'I assessed my fitness honestly' },
				{ id: 'dates-rough', label: 'I have rough travel dates' },
			],
		},
		research: {
			objective: 'Lock season, duration, and budget',
			why: 'Monsoon road landslides to Syabrubesi are a real risk — avoid June–August',
			estimatedTime: '25 minutes',
			prerequisites: ['dream'],
			taskChecklist: [
				{ id: 'season-chosen', label: 'Best season chosen (avoid monsoon Jun–Aug)' },
				{ id: 'duration-set', label: 'Duration decided (7–9 days)' },
				{ id: 'budget-range', label: 'Budget understood ($700–1,500)' },
			],
		},
		flights: {
			objective: 'Book international flights to Kathmandu',
			why: 'Langtang has no domestic flight — road access only',
			estimatedTime: '1 hour',
			prerequisites: ['visa'],
			taskChecklist: [
				{ id: 'intl-booked', label: 'International flights booked' },
			],
		},
		insurance: {
			objective: 'Insurance with helicopter evacuation and 4,500m+ altitude',
			why: 'Remote valley — evacuation is helicopter-dependent',
			estimatedTime: '30 minutes',
			prerequisites: ['research'],
			taskChecklist: [
				{ id: 'policy-purchased', label: 'Policy purchased' },
				{ id: 'altitude-verified', label: 'Altitude limit verified' },
				{ id: 'emergency-saved', label: 'Emergency number saved offline' },
			],
		},
		packing: {
			objective: 'Pack for 7 days in Langtang Valley',
			why: 'Cold at Kyanjin Gompa — pack warm layers',
			estimatedTime: '2 hours',
			prerequisites: ['research'],
			usesPackingChecklist: true,
			taskChecklist: [
				{ id: 'boots-broken-in', label: 'Boots broken in' },
				{ id: 'checklist-complete', label: 'Checklist completed' },
			],
		},
		permits: {
			objective: 'Langtang National Park permit + TIMS if required',
			why: 'Checkpoint at park entry — no permit, no entry',
			estimatedTime: '10 minutes',
			prerequisites: ['flights'],
			taskChecklist: [
				{ id: 'park-understood', label: 'Park permit requirement understood' },
				{ id: 'tims-checked', label: 'TIMS policy verified' },
			],
		},
		'permit-offices': {
			objective: 'Obtain park permit in Kathmandu',
			why: 'Get permits before the long drive to Syabrubesi',
			estimatedTime: '45 minutes',
			prerequisites: ['permits'],
			taskChecklist: [
				{ id: 'park-obtained', label: 'Langtang National Park permit obtained' },
			],
		},
		lukla: {
			objective: 'Reach Syabrubesi trailhead',
			why: '7–8 hour jeep — start fresh the next morning',
			estimatedTime: '1 day travel',
			prerequisites: ['kathmandu'],
			taskChecklist: [
				{ id: 'jeep-booked', label: 'Jeep to Syabrubesi arranged' },
				{ id: 'syabrubesi-arrived', label: 'Arrived and rested at Syabrubesi' },
			],
		},
		trek: {
			objective: 'Trek to Kyanjin Gompa and back',
			why: 'The valley rewards slow travel — support rebuilt Tamang communities',
			estimatedTime: '5–7 days on trail',
			prerequisites: ['lukla'],
			taskChecklist: [
				{ id: 'kyanjin-reached', label: 'Reached Kyanjin Gompa' },
				{ id: 'safe-return', label: 'Returned safely to Syabrubesi' },
			],
		},
	}),
};
